import React from 'react';
import { Landmark } from 'lucide-react';
import { SA_BANKS } from '../../config/banks';

/** Step 5 of 6 — Bank Details. Fully optional/skippable — payouts aren't live yet,
 *  this just gets the info on file ahead of time. */
const StepBank = ({ data, onChange }) => (
  <div className="space-y-6">
    <div className="bg-blue-50 border border-blue-100 text-blue-800 text-xs rounded-lg p-3">
      This step is <span className="font-semibold">optional</span>. We're not processing payouts yet —
      adding your bank details now just saves you a step later. You can skip and add this anytime from your profile.
    </div>

    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
        <Landmark size={16} /> Bank
      </label>
      <select
        data-testid="bank-name-select"
        value={data.bankName}
        onChange={(e) => onChange({ bankName: e.target.value })}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-[#37b34a] focus:border-transparent outline-none"
      >
        <option value="">Select a bank… (optional)</option>
        {SA_BANKS.map((b) => <option key={b} value={b}>{b}</option>)}
      </select>
    </div>

    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2">Account Holder Name</label>
      <input
        type="text" data-testid="bank-account-holder-input" value={data.bankAccountHolder}
        onChange={(e) => onChange({ bankAccountHolder: e.target.value })}
        placeholder="As it appears on your bank account"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#37b34a] focus:border-transparent outline-none"
      />
    </div>

    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-2">Account Number</label>
      <input
        type="text" data-testid="bank-account-number-input" value={data.bankAccountNumber}
        onChange={(e) => onChange({ bankAccountNumber: e.target.value.replace(/[^0-9]/g, '') })}
        placeholder="e.g., 1234567890"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#37b34a] focus:border-transparent outline-none"
      />
    </div>
  </div>
);

export default StepBank;
